export default __webpack_public_path__ + "static/allergy-amulet-2-4d6eed84414c82b8487ac809b3b43c9c.webp";